/**
 * API Action Creators for Recent Deals
 * Contains actions that make API calls (side effects) using redux-api-middleware.
 */
import { RSAA } from 'redux-api-middleware';
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import { FETCH_RECENT_DEALS_REQUEST, FETCH_RECENT_DEALS_SUCCESS, FETCH_RECENT_DEALS_FAILURE } from './actions';

export const fetchRecentDeals = (bffEndpoint: string, coOrgId: string, mmdId: string) => {
    const queryParams = `coOrgId=${encodeURIComponent(coOrgId)}`;
    const mmdIdParam = mmdId ? `&mmdId=${encodeURIComponent(mmdId)}` : '';

    const endpoint = `${bffEndpoint}?${queryParams}${mmdIdParam}`;

    const request: RSAACallRequest = {
        endpoint,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        types: [FETCH_RECENT_DEALS_REQUEST, FETCH_RECENT_DEALS_SUCCESS, FETCH_RECENT_DEALS_FAILURE],
        fetch: async (input: RequestInfo | URL, init?: RequestInit) => await fetch(input, init)
    };

    return {
        [RSAA]: request
    } as RSAACallAction;
};
